import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
import classNames from 'classnames/bind';

import Button from 'components/Button';
import ZoomableImage from 'components/ZoomableImage';
import BlockTitle from '../BlockTitle';

import styles from './ParagraphMultipleImages.module.scss';
const cx = classNames.bind(styles);

const ParagraphMultipleImages = ({ data }) => (
  <div className={cx('root')}>
    {data.map(({ title, image, caption, cta_button }, i) => (
      <div key={i} className={cx('column')}>
        {title && <BlockTitle title={title} />}
        <div className={cx('img')}>
          <ZoomableImage src={image.url} alt={image.alt} />
        </div>
        {caption && <div className={cx('caption')}>{caption}</div>}
        {cta_button.link && (
          <div className={cx('cta-wrap')}>
            <Button
              href={cta_button.link}
              tag={'a'}
              color="bismark"
              isAutoWidth={true}
            >
              {cta_button.btn_text}
            </Button>
          </div>
        )}
      </div>
    ))}
  </div>
);

ParagraphMultipleImages.propTypes = {
  data: arrayOf(
    shape({
      title: string,
      image: shape({
        url: string.isRequired,
        alt: string.isRequired,
      }).isRequired,
      cta_button: shape({ link: string, btn_text: string }),
      caption: string,
    })
  ).isRequired,
};

export default ParagraphMultipleImages;



// WEBPACK FOOTER //
// ./src/pages/TechnicalDocument/components/ParagraphMultipleImages/ParagraphMultipleImages.js